import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "lmb_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((cur) => {
      const idx = cur.findIndex((i) => i.slug === item.slug && i.type === item.type);
      if (idx >= 0) {
        const next = [...cur];
        next[idx] = { ...next[idx], qty: next[idx].qty + (item.qty || 1) };
        return next;
      }
      return [...cur, { ...item, qty: item.qty || 1 }];
    });
    setOpen(true);
  };

  const removeItem = (slug, type) => {
    setItems((cur) => cur.filter((i) => !(i.slug === slug && i.type === type)));
  };

  const updateQty = (slug, type, qty) => {
    setItems((cur) => cur.map((i) => (i.slug === slug && i.type === type ? { ...i, qty: Math.max(1, qty) } : i)));
  };

  const clear = () => setItems([]);
  const removePieces = useCallback(() => setItems((cur) => cur.filter((i) => i.type !== "piece")), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * (i.prix || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, removePieces, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
